export default {
    ABERTO: 1,
    FINALIZADO: 2,
    REAGENDADO: 5,
    MODIFICADO: 6
}